/* eslint-disable @next/next/no-img-element */
import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import styles from "@/src/styles/footer.module.css";
import LanguageSelection from "@/src/Components/Navigation/LanguageSelection";

function Footer(props) {
  return (
    <Box sx={{ py: 0, padding: { xs: "40px 0 0", sm: "50px 0 0" } }}>
      <div className={styles.footerBox}>
        <Container maxWidth={false} className={"containerWidth"}>
          <div className={styles.footerWidgets}>
            <div className={styles.footerContactWidget}>
              <img src={"/images/logo.svg"} alt={"logo"} />
              <div className={styles.footerLanguage}>
                <div className={styles.smallText}>Site language</div>
                <LanguageSelection
                  sx={{ marginRight: "10px", marginTop: "5px" }}
                  id={props.id}
                />
              </div>
              <div className={styles.followIcons}>
                <a href={"#"}>
                  <img src={"/icons/youtube.svg"} alt={"youtube-icon"} />{" "}
                  YouTube
                </a>
                <a href={"#"}>
                  <img src={"/icons/linkedin.svg"} alt={"linkedin-icon"} />
                  Linkedin
                </a>
                <a href={"#"}>
                  <img src={"/icons/twitter.svg"} alt={"twitter-icon"} />
                  Twitter
                </a>
                <a href={"#"}>
                  <img src={"/icons/facebook.svg"} alt={"facebook-icon"} />
                  Facebook
                </a>
                <a href={"#"}>
                  <img src={"/icons/instagram.svg"} alt={"instagram-icon"} />
                  Instagram
                </a>
              </div>
            </div>

            <div className={styles.footerWidget}>
              <h5 className={styles.widgetTitle}>Header 1</h5>
              <div className={styles.widgetText}>
                <ul>
                  <li>
                    <a href={"#"}>Menu 1</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 2</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 3</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 4</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 5</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className={styles.footerWidget}>
              <h5 className={styles.widgetTitle}>Header 2</h5>
              <div className={styles.widgetText}>
                <ul>
                  <li>
                    <a href={"#"}>Menu 1</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 2</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 3</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 4</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 5</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className={styles.footerWidget}>
              <h5 className={styles.widgetTitle}>Header 3</h5>
              <div className={styles.widgetText}>
                <ul>
                  <li>
                    <a href={"#"}>Menu 1</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 2</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 3</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 4</a>
                  </li>
                  <li>
                    <a href={"#"}>Menu 5</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className={styles.footerWidget}>
              <h5 className={styles.widgetTitle}>Header 4</h5>
              <div className={styles.widgetText}>
                <ul>
                  <li>
                    <a href={"#"}>Help Center</a>
                  </li>
                  <li>
                    <a href={"#"}>Terms</a>
                  </li>
                  <li>
                    <a href={"#"}>Privacy</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.smallText}>©2024 Tutorcert</div>
        </Container>
      </div>
    </Box>
  );
}

export default Footer;
